import { useMemo } from 'react';
import { getStoredAuth } from '@/lib/auth';
import type { FeatureName } from '@/lib/sdk/accounts/types';

export const useFeatureAccess = () => {
  const auth = getStoredAuth();

  return useMemo(() => {
    const role = auth?.role;
    const features = auth?.features;

    const isAdmin = role === 'zeno_dashboard_admin';

    const canAccess = (feature: FeatureName): boolean => {
      if (isAdmin) return true;
      return features?.[feature]?.enabled === true;
    };

    const canPerformAction = (feature: FeatureName, action: string): boolean => {
      if (isAdmin) return true;
      const config = features?.[feature];
      if (!config?.enabled) return false;
      return config.actions.includes(action);
    };

    return { isAdmin, canAccess, canPerformAction };
  }, [auth?.role, auth?.features]);
};
